// extracted by mini-css-extract-plugin
export default {"form":"vG7E3Dr"};